define('lib/Podio.Transport.Space',['require','lib/Podio.Transport','lib/Podio.Routes'],function(require) {

  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  /* Layouts */
  function getShareSpaceModalLayout(spaceId, callback, baseUrl) {
    return transport.getJSON(routes.json_share_space_modal_path(spaceId), {}, callback);
  }

  function getShareSpaceAppsModalLayout(spaceId, callback, baseUrl) {
    return transport.getJSON(routes.json_share_space_apps_path(spaceId), {}, callback);
  }

  function getShareSpaceFeaturesModalLayout(spaceId, appIds, callback, baseUrl) {
    return transport.getJSON(
      routes.json_share_space_features_path(spaceId),
      { requestData: {app_ids : appIds} },
      callback
    );
  }

  // Arguments:
  // PHP: spaceName, orgId, callback
  // Rails: elmForm, callback
  function createSpace() {
    var callback;
    var elmForm = arguments[0];
    callback = arguments[1];
    return transport.requestFromElement(elmForm, callback);
  }

  // Arguments:
  // PHP: orgId, callback
  // Rails: baseUrl, callback
  function getCreateSpaceModalLayout(url, callback) {
    return transport.getJSON(url, {}, callback);
  }

  return {
    getShareSpaceModalLayout: getShareSpaceModalLayout,
    getShareSpaceFeaturesModalLayout: getShareSpaceFeaturesModalLayout,
    getShareSpaceAppsModalLayout: getShareSpaceAppsModalLayout,
    getCreateSpaceModalLayout: getCreateSpaceModalLayout,
    createSpace: createSpace
  };

});



